import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getAllDayTours,
  createDayTour,
  addDayTourPhotos,
  editDayTour,
  deleteDayTour,
  deleteDayTourPhoto,
  getAllAccommodations,
  getSingleAccommodation,
  getAllDrivers,
  createDriver,
  deleteDriver,
  editDriver,
  addDriverCarPhotos,
  getAllTourguides,
  createTourguide,
  deleteDriverCarPhoto,
  addDriverPhoto,
  deleteTourguide,
  editTourguide,
  addTourguidePhoto,
  createAccommodation,
  deleteAccommodation,
  editAccommodation,
  addAccommodationFeaturedPhoto,
  addAccommodationPhotos,
  deleteAccommodationPhoto,
  editAccommodationShare,
  getRoomsCategories,
  syncRoomCategories,
  updateOrCreateSeasonsAndPrices,
} from "./TourOperatorAxios";
//==DayTour ===========================================================================
// Get All Day Tours
export const GetAllDayTours = createAsyncThunk(
  "Tour-Operator/get-all-daytours",
  async (id, thunkAPI) => {
    try {
      return getAllDayTours(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Create Day Tour
export const CreateDayTour = createAsyncThunk(
  "Tour-Operator/create-daytour",
  async (data, thunkAPI) => {
    try {
      return createDayTour(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Day Tour Photos
export const AddDayTourPhotos = createAsyncThunk(
  "Tour-Operator/add-daytour-photos",
  async (data, thunkAPI) => {
    try {
      return addDayTourPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Edit Day Tour
export const EditDayTour = createAsyncThunk(
  "Tour-Operator/edit-daytour",
  async (data, thunkAPI) => {
    try {
      return editDayTour(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Day Tour
export const DeleteDayTour = createAsyncThunk(
  "Tour-Operator/delete-daytour",
  async (id, thunkAPI) => {
    try {
      return deleteDayTour(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Day Tour Photo
export const DeleteDayTourPhoto = createAsyncThunk(
  "Tour-Operator/delete-daytour-photo",
  async (id, thunkAPI) => {
    try {
      return deleteDayTourPhoto(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//==Accommodations ===========================================================================
// Get All Accommodations
export const GetAllAccommodations = createAsyncThunk(
  "Tour-Operator/get-all-accommodations",
  async (id, thunkAPI) => {
    try {
      return getAllAccommodations(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get All Accommodations
export const GetSingleAccommodation = createAsyncThunk(
  "Tour-Operator/get-single-accommodation",
  async (id, thunkAPI) => {
    try {
      return getSingleAccommodation(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Create Accommodation
export const CreateAccommodation = createAsyncThunk(
  "Tour-Operator/create-accommodation",
  async (data, thunkAPI) => {
    try {
      return createAccommodation(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Accommodation
export const DeleteAccommodation = createAsyncThunk(
  "Tour-Operator/delete-accommodation",
  async (id, thunkAPI) => {
    try {
      return deleteAccommodation(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Edit Accommodation
export const EditAccommodation = createAsyncThunk(
  "Tour-Operator/edit-accommodation",
  async (data, thunkAPI) => {
    try {
      return editAccommodation(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Edit Accommodation Share
export const EditAccommodationShare = createAsyncThunk(
  "Tour-Operator/edit-accommodation-share",
  async (data, thunkAPI) => {
    try {
      return editAccommodationShare(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Accommodation Featured Photo
export const AddAccommodationFeaturedPhoto = createAsyncThunk(
  "Tour-Operator/add-accommodation-feaured-photo",
  async (data, thunkAPI) => {
    try {
      return addAccommodationFeaturedPhoto(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Accommodation Photos
export const AddAccommodationPhotos = createAsyncThunk(
  "Tour-Operator/add-accommodation-photos",
  async (data, thunkAPI) => {
    try {
      return addAccommodationPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Accommodation Photo
export const DeleteAccommodationPhoto = createAsyncThunk(
  "Tour-Operator/delete-accommodation-photo",
  async (id, thunkAPI) => {
    try {
      return deleteAccommodationPhoto(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get All Drivers
export const GetAllDrivers = createAsyncThunk(
  "Tour-Operator/get-all-drivers",
  async (id, thunkAPI) => {
    try {
      return getAllDrivers(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Create New Driver
export const CreateDriver = createAsyncThunk(
  "Tour-Operator/create-driver",
  async (data, thunkAPI) => {
    try {
      return createDriver(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Driver
export const DeleteDriver = createAsyncThunk(
  "Tour-Operator/delete-driver",
  async (id, thunkAPI) => {
    try {
      return deleteDriver(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Edit Driver
export const EditDriver = createAsyncThunk(
  "Tour-Operator/edit-driver",
  async (data, thunkAPI) => {
    try {
      return editDriver(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Driver Car Photos
export const AddDriverCarPhotos = createAsyncThunk(
  "Tour-Operator/add-driver-carphotos",
  async (data, thunkAPI) => {
    try {
      return addDriverCarPhotos(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Driver Car Photo
export const DeleteDriverCarPhoto = createAsyncThunk(
  "Tour-Operator/delete-driver-carphoto",
  async (id, thunkAPI) => {
    try {
      return deleteDriverCarPhoto(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Driver  Photo
export const AddDriverPhoto = createAsyncThunk(
  "Tour-Operator/add-driver-photos",
  async (data, thunkAPI) => {
    try {
      return addDriverPhoto(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get All Tourguides
export const GetAllTourguides = createAsyncThunk(
  "Tour-Operator/get-all-tourguides",
  async (id, thunkAPI) => {
    try {
      return getAllTourguides(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Create New Tourguide
export const CreateTourguide = createAsyncThunk(
  "Tour-Operator/create-tourguide",
  async (data, thunkAPI) => {
    try {
      return createTourguide(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Tourguide
export const DeleteTourguide = createAsyncThunk(
  "Tour-Operator/delete-tourguide",
  async (id, thunkAPI) => {
    try {
      return deleteTourguide(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add Tourguide Car Photos
export const AddTourguidePhoto = createAsyncThunk(
  "Tour-Operator/add-tourguide-photos",
  async (data, thunkAPI) => {
    try {
      return addTourguidePhoto(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Edit Tourguide
export const EditTourguide = createAsyncThunk(
  "Tour-Operator/edit-tourguide",
  async (data, thunkAPI) => {
    try {
      return editTourguide(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get Rooms Categories
export const GetRoomsCategories = createAsyncThunk(
  "Tour-Operator/get-rooms-categories",
  async (thunkAPI) => {
    try {
      return getRoomsCategories();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// update  Accommodation Rooms Categories
export const SyncRoomCategories = createAsyncThunk(
  "Tour-Operator/syncRoomCategories",
  async (data, thunkAPI) => {
    try {
      return syncRoomCategories(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// updateOrCreateSeasonsAndPrices
export const UpdateOrCreateSeasonsAndPrices = createAsyncThunk(
  "Tour-Operator/updateOrCreateSeasonsAndPrices",
  async (data, thunkAPI) => {
    try {
      return updateOrCreateSeasonsAndPrices(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  day_tours: [],
  single_tour: [],
  accommodations: [],
  drivers: [],
  single_driver: [],
  single_tourguide: [],
  single_accommodation: [],
  tourguides: [],
  rooms_categories: [],

  isLoading: false,

  isTourSuccess: false,
  isHotelSuccess: false,
  isDriverSuccess: false,
  isTourguideSuccess: false,
  isRoomsCategoriesSuccess: false,

  isSingleHotelSuccess: false,

  isSuccess: false,
  isError: false,
  destination: "",
  message: "",
  item: false,
  show: false,
  Created: false,
  IsDeleted: false,
};

// Country Slice .............
export const TourOperator = createSlice({
  name: "TourOperator",
  initialState,
  reducers: {
    resetCreated: (state) => {
      state.Created = false;
    },
    resetDayTours: (state) => {
      state.isTourSuccess = false;
    },
    resetAccommodations: (state) => {
      state.isHotelSuccess = false;
    },
    resetDrivers: (state) => {
      state.isDriverSuccess = false;
    },
    resetTourguides: (state) => {
      state.isTourguideSuccess = false;
    },
    resetSingleHotel: (state) => {
      state.isSingleHotelSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      // Get All Day Tours
      .addCase(GetAllDayTours.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllDayTours.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourSuccess = true;
        state.isError = false;
        state.day_tours = action.payload.data;
      })
      .addCase(GetAllDayTours.rejected, (state, action) => {
        state.isLoading = false;
        state.isTourSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Create Day Tour cases
      .addCase(CreateDayTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateDayTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.Created = true; // This triggers navigation
        state.isTourSuccess = false;
        toast.success(
          action.payload?.message || "Day Tour created successfully!"
        );
      })
      .addCase(CreateDayTour.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload || "An error occurred.");
      })

      // add Day Tour Photos
      .addCase(AddDayTourPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(AddDayTourPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.isTourSuccess = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(AddDayTourPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Edit Day Tour
      .addCase(EditDayTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditDayTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.Created = true;
        state.isTourSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(EditDayTour.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Day Tour
      .addCase(DeleteDayTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteDayTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.isTourSuccess = false;
        state.IsDeleted = !state.IsDeleted;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteDayTour.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Day Tour Photo
      .addCase(DeleteDayTourPhoto.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteDayTourPhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.Created = true;
        state.isTourSuccess = false;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteDayTourPhoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Get All Accommodations
      .addCase(GetAllAccommodations.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(GetAllAccommodations.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isHotelSuccess = true;
        state.isError = false;
        state.accommodations = action.payload.data;
      })
      .addCase(GetAllAccommodations.rejected, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Get Single Accommodation
      .addCase(GetSingleAccommodation.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(GetSingleAccommodation.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isSingleHotelSuccess = true;
        state.isError = false;
        state.single_accommodation = action.payload.data;
      })
      .addCase(GetSingleAccommodation.rejected, (state, action) => {
        state.isLoading = false;
        state.isSingleHotelSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Create New Accommodation
      .addCase(CreateAccommodation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateAccommodation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(CreateAccommodation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Accommodation
      .addCase(DeleteAccommodation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteAccommodation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.IsDeleted = !state.IsDeleted;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteAccommodation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error;
      })

      // Edit Accommodation
      .addCase(EditAccommodation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditAccommodation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(EditAccommodation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error;
      })

      // Edit Accommodation Share
      .addCase(EditAccommodationShare.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(EditAccommodationShare.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(EditAccommodationShare.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // add Accommodation Featured Photo
      .addCase(AddAccommodationFeaturedPhoto.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(AddAccommodationFeaturedPhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(AddAccommodationFeaturedPhoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // add Accommodation Photos
      .addCase(AddAccommodationPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(AddAccommodationPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(AddAccommodationPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Accommodation Photo
      .addCase(DeleteAccommodationPhoto.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteAccommodationPhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteAccommodationPhoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Get All Drivers
      .addCase(GetAllDrivers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllDrivers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = true;
        state.isError = false;
        state.drivers = action.payload.data;
      })
      .addCase(GetAllDrivers.rejected, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Create New Driverr
      .addCase(CreateDriver.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(CreateDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Driver
      .addCase(DeleteDriver.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = false;
        state.IsDeleted = !state.IsDeleted;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Edit Driver
      .addCase(EditDriver.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(EditDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // add Driver Car Photos
      .addCase(AddDriverCarPhotos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(AddDriverCarPhotos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(AddDriverCarPhotos.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Driver Car Photo
      .addCase(DeleteDriverCarPhoto.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteDriverCarPhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteDriverCarPhoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // add Driver  Photo
      .addCase(AddDriverPhoto.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(AddDriverPhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDriverSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(AddDriverPhoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Get All Tourguides
      .addCase(GetAllTourguides.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllTourguides.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourguideSuccess = true;
        state.isError = false;
        state.tourguides = action.payload.data;
      })
      .addCase(GetAllTourguides.rejected, (state, action) => {
        state.isLoading = false;
        state.isTourguideSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Create New Tourguide
      .addCase(CreateTourguide.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateTourguide.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourguideSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(CreateTourguide.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Delete Tourguide
      .addCase(DeleteTourguide.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteTourguide.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourguideSuccess = false;
        state.isError = false;
        state.IsDeleted = !state.IsDeleted;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteTourguide.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Edit Tourguide
      .addCase(EditTourguide.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditTourguide.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourguideSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(EditTourguide.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // add Tourguide  Photo
      .addCase(AddTourguidePhoto.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(AddTourguidePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourguideSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(AddTourguidePhoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      // Get Rooms Categories
      .addCase(GetRoomsCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetRoomsCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isRoomsCategoriesSuccess = true;
        state.isError = false;
        state.rooms_categories = action.payload.data;
      })
      .addCase(GetRoomsCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isRoomsCategoriesSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      //SyncRoomCategories
      .addCase(SyncRoomCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(SyncRoomCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(SyncRoomCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      })

      //updateOrCreateSeasonsAndPrices
      .addCase(UpdateOrCreateSeasonsAndPrices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UpdateOrCreateSeasonsAndPrices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isHotelSuccess = false;
        state.isError = false;
        state.Created = true;
        toast.success(action.payload?.message);
      })
      .addCase(UpdateOrCreateSeasonsAndPrices.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
      });
  },
});

export const resetStateTourOperator = createAction("Reset_all");
export default TourOperator.reducer;
export const {
  resetCreated,
  resetDayTours,
  resetAccommodations,
  resetDrivers,
  resetTourguides,
  resetSingleHotel,
} = TourOperator.actions;
